import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  InitializeAddSystemsContract,
  InitializeAddSystemsRequest,
  InitializeAddSystemsResponse
} from '@bliks-io/contracts';
import { apiClient } from '../client';
import { invalidateEntity } from '../cache-invalidation';
import { organizationKeys } from '../query-keys';

export function useInitializeSystems() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: InitializeAddSystemsRequest) => {
      const { data: response } = await apiClient.post<InitializeAddSystemsResponse>(
        InitializeAddSystemsContract.path,
        data
      );
      return response;
    },
    onSuccess: () =>
      // Awaited (returned) on purpose: the wizard's autosave flush-and-clear
      // drops committed rows from the draft the moment mutateAsync resolves —
      // the existing-entities table must already show them.
      Promise.all([
        invalidateEntity(queryClient, 'system'),
        // First import stamps initialization.systems on the organization.
        queryClient.invalidateQueries({ queryKey: organizationKeys.all })
      ])
  });
}
